import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import Agreement from './Agreement';
import ScopeServices from './ScopeServices';

const findLocationServices = (scopeServices) => {
  const filteredResults = scopeServices.filter((scopeService) => {
    return scopeService.scope === 'LOCATION_SERVICES';
  });
  return filteredResults.length > 0;
};

const FoundVehicle = ({ vinsToConsent, scopeServices, onAuthorize, onChangeVehicles }) => {
  const [hasAgreed, setHasAgreed] = useState(false);
  const [hasLocationServices, setHasLocationServices] = useState(false);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (scopeServices) {
      if (findLocationServices(scopeServices)) setHasLocationServices(true);
      else setHasAgreed(true);
    }
  }, [scopeServices]);

  const onAgreement = () => {
    setHasAgreed((prevValue) => !prevValue);
  };

  return (
    <div>
      {scopeServices && <ScopeServices scopeServices={scopeServices} i18n={i18n} />}
      <div className='subheading' style={{ marginTop: '2em' }}>
        {i18n.t('papi.general.selectedVehicles.lable')}
      </div>
      <ul>
        {vinsToConsent &&
          vinsToConsent.map(({ makeDescription, modelDescription, vin, year }) => (
            <li key={vin}>
              {year} {makeDescription} {modelDescription} ({vin})
            </li>
          ))}
      </ul>
      <div>
        <button id='change-btn' style={{ marginBottom: '2em' }} className='clear-button' onClick={onChangeVehicles}>
          {i18n.t('papi.general.changeVehicles.lable')}
        </button>
        {hasLocationServices && (
          <Agreement
            text={i18n.t('papi.general.proceeding.message.10')}
            hasAgreed={hasAgreed}
            onAgreement={onAgreement}
          />
        )}
        <button
          id='authorize-btn'
          style={{ marginBottom: '1em' }}
          className='square-button'
          onClick={onAuthorize}
          disabled={hasLocationServices && !hasAgreed}
        >
          {i18n.t('papi.general.authorize.lable')}
        </button>
      </div>
    </div>
  );
};

FoundVehicle.propTypes = {
  vinsToConsent: PropTypes.array,
  scopeServices: PropTypes.array,
  onAuthorize: PropTypes.func,
  onChangeVehicles: PropTypes.func,
};

export default FoundVehicle;
